import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface getInvDetailListRequest extends BaseRequest {
  invId: string; //邀请活动ID
  pageNum: number;
  pageSize: number;
}
export interface InvTaskResVO {
  /**
   * 被邀请加星手机号
   */
  starPhone: string;
  /**
   * 被邀请人通行证
   */
  binvUid: string;
  /**
   * 项目id
   */
  projectId: string;
  /**
   * 任务编码
   * */
  taskCode: string;
  /**
   * 任务名称
   */
  taskName: string;
  /**
   * 邀请状态
   * 1-邀请中,
   * 2-成功,
   * 3-失败(通行证注册早于邀请短信30天),
   * 4-失败(设备注册早于邀请短信30天),
   * 5-失败(设备登记失败),
   * 6-失败-任务结束,
   * 7-失败-已在其它任务成功过
   * 99-失败(其它原因)
   */
  status: string;
  /**
   * 奖励抽奖次数
   */
  rewardNum: string;
  /**
   * 领取状态
   * 空 不能领取；0 未领取；1 已领取
   */
  collectStatus: string;
}

export interface InvTaskPageResVO {
  /**
   * 领取状态
   * 0 可领取
   */
  collectStatus: string;
  /**
   * 分页列表
   */
  list: InvTaskResVO[];
  /**总条数
   * */
  totalCount: number;
}

interface getSumCashResponse extends BaseResponse {
  Data: InvTaskPageResVO;
}

/**
 * 查询邀请人邀请明细
 *
 * */
export async function getInvDetailList(request: getInvDetailListRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/getInvDetailList');
  return DsbcApi.fetch<getSumCashResponse>(url, request, true, options);
}
